<template>
  <div>
    <div style="margin-top: -30px; margin-right: 20px; margin-bottom: 15px">
      <CRow style="flex-flow: row-reverse">
         <CButton
          block
          color="danger"
          style="
            width: fit-content;
            height: fit-content;
            margin-top: 0.5rem;
            margin-right: 10px;
            float: right;
          "
          @click="deleteModal = true"
          >Delete Product</CButton
        >
        <CButton
          block
          color="danger"
          @click="addproduct"
          style="
            width: fit-content;
            height: fit-content;
            margin-top: 0.5rem;
            margin-right: 10px;
            float: right;
          "
          >Add Product</CButton
        >
      </CRow>
    </div>
<div class="row">
  <div class="col-3" >
     <p><strong>Search:</strong><input type="text" class="form-control" v-model="keyword"></p>
  <!-- <p><strong>Discount:</strong>
 <label class="container">Deals
  <input type="checkbox" @change="featured($event)" v-model="prod.discount" value=true>
  <span class="checkmark"></span>
</label>
 <label class="container">No Deals
  <input type="checkbox"  @change="nofeatured($event)" v-model="prod.nofeatured" value=true>
  <span class="checkmark"></span>
</label>  </p>
   -->
  <p><strong>Availability:</strong>
<label class="container">In Stock
  <input type="checkbox"  @change="instock($event)" v-model="prod.available" value=true>
  <span class="checkmark"></span>
</label>
 <label class="container">Include Out of Stock
  <input type="checkbox" @change="outofstock($event)" v-model="prod.available2" value='true'>
  <span class="checkmark"></span>
</label>  </p>
  <p><strong>Featured:
    <label class="container">Yes
  <input type="checkbox" @change="checkfeatured($event)" v-model="prod.featured" value=true>
  <span class="checkmark"></span>
</label>
<label class="container">No
  <input type="checkbox" @change="nofeatured($event)" v-model="prod.notfeatured" value=false>
  <span class="checkmark"></span>
</label>
  </strong>
  </p>
<div>
  <p><strong>Category:
                  <CCard>
                    <CCardHeader
                      @click="cardCollapsecat = !cardCollapsecat"
                      class="btn text-left"
                    >
                      Selected Category({{ selected_cat.length }})
                    </CCardHeader>
                    <CCollapse :show="cardCollapsecat">
                      <CCardBody class="m-1">
                        <div
                          class="panel panel-default"
                          v-for="choice in category_data"
                          v-bind:key="choice"
                        >
                          <div class="panel-heading">
                            <input
                              type="checkbox"
                              v-bind:id="choice"
                              v-bind:value="choice"
                              v-model="selected_cat"
                              @change="filtercatgory"
                            />
                            &nbsp;{{ choice }}
                          </div>
                        </div>
                      </CCardBody>
                    </CCollapse>
                  </CCard>
                  </strong>
  </p>
</div>

  </div>
    <div class="col-9">
              <div class="row cur-point">
          <div v-if="loader == true" style="padding-top:7rem;padding-bottom:7rem">
                        <TheLoader /><p style="text-align:center">Loading....</p>
          </div>
          
              	<div v-else-if="product!=''" class="product-card" v-for="(product, index) in computedProducts" :key="index">
		<div class="badge" v-if="product.discount !=0">{{product.discount}}</div>
                <div >
                   <label class="container1">
  <input type="checkbox" @change="deleteprodct($event,product)">
  <span class="checkmark1"></span>
</label>
                </div>
		<div class="product-tumb">
			<img :src="product.Image" alt="" style="padding:10px;border-radius:2rem;width:150px">
		</div>
		<div class="product-details">
			<span class="product-catagory" v-if="product.available == true"> In stock</span>
      			<span class="product-catagory" v-if="product.available == false">Currently unavailable</span>

			<h4 ><a >{{product.name | truncate(20, "...")}}</a></h4>
			<div class="product-bottom-details">
				<div class="product-price"><small>{{symbol}}{{product.mrp}}</small>{{symbol}}{{product.unitprice}}</div>
				<div class="product-links"  @click="editOrder(product)">
					<a><i class="fas fa-angle-right fa-lg" ></i></a>
				</div>
			</div>
		</div>
	</div>
  <div v-else>
    <p style="font-weight:700">No Data Found</p>

  </div>
      </div>

  </div>

</div>
 












<div class="shell">

</div>
<CModal
      title="Delete Product"
      size="sm"
      :show.sync="deleteModal"
      :centered="true"
    >
      Are you sure to delete product?
      <template #footer>
        <CButton @click="deleteModal=false" color="danger">No</CButton>
        <CButton @click="deletepro" color="success">Yes</CButton>
      </template> 
    </CModal>
  </div>
  
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/jszip.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/xlsx.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/vue/2.5.16/vue.js"></script>

<script>
import firebase from "firebase";
import Upload from "../components/fileupload";
import TheLoader from "../components/TheLoader.vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast, {
  // One of the options
  position: "top-right",
});
const fields = [
    {
    key: "image",
    label: "Product",_style:"width:2px"
  },

  {
    key: "name",
    label: "",
  },

  {
    key: "category",
    label: "Price",
  },

  {
    key: "select",
    label: "Action",
  },
];
export default {
  name: "producttable",
  components: {
    Upload,
    TheLoader,
  },
  data: () => {
    return {
      deleteModal:false,
      selected_meals:[],
      cardCollapse:false,
      featured:false,
      cardCollapsecat:false,
      selected_cat:[],
      Idspro:[],
            catalog_data: [],
      displayList:false,
      loader: false,
      zero:false,
      fields,
      delete:false,
      productId:[],
      userId: "",
      itemsvaluee: "",
      id: "",
      parseCsv: null,
      datavalue: "",
      updatedatavalue: "",
      symbol: "",
      nodata:'',
      filtercat:[],
      items: [],
            keyword: '',
            prod:{},
            instocking:false,
            outofstocking:false,
      idvalues: [],
      values: [],
      itemdelete: null,
      checker: true,
      category: null,
      upload: false,
      catalog_false: false,
      catalog_data: [],
      category_false: false,
      category_data: [],
      discount:0,
      map: {
        catalog: "catalog",
        category: "category",
        name: "name",
        description: "description",
        unitprice: "unitprice",
        image: "image",
      },
      options: [
        "Edit options",
        "Edit Attribute",
        "Add Image",
        "Upload Files",
        "Define Taxes & Shipping",
      ],
    };
  },
  watch: {
    onChangeEventHandler: function (event) {
      console.log("hai", event);
    },
  },
    computed: {
    computedProducts: function () {
console.log(this.items)
// if(this.items.length==0){
//   this.zero=true;
//   this.nodata="No data found";
// }

      return this.items.filter((item) => {

        return (this.keyword.length === 0 || item.name.toLowerCase().includes(this.keyword))
        // (item.available!=''?item.available:'No data available')&&(item.available==this.prod.available)&&(!item.available==this.prod.available2)
    })
    
    }
  },

  methods: {
    instock(e){
      console.log(e)
      this.instocking=e.target.checked;
      console.log("ACTIVE")
      if(e.target.checked == true){
        this.items=[];
        this.loader=true;
        const db = firebase.firestore();
      db.collection("products")
        .where("id", "==", firebase.auth().currentUser.uid)
        .where("available","==", true)
        .get()
        .then((snapshot) => {
          this.loader = false;
          snapshot.forEach((doc) => {
            this.id = doc.id;
              this.datavalue = {
                userid: doc.id,
                Image: doc.data().image,
                Id: doc.data().id,
                category: doc.data().category,
                description: doc.data().description,
                name: doc.data().name,
                skucode: doc.data().skucode,
                unitprice: doc.data().unitprice,
                mrp: doc.data().mrp,
                featured: doc.data().featured,
                available: doc.data().available,
                catalog: doc.data().catalog,
                variant: doc.data().variant,
                variants: doc.data().variants,
                extra: doc.data().extra,
                extras: doc.data().extras,
                weight: doc.data().weight,
                barcode: doc.data().barcode,
                brand: doc.data().brand,
                discount: doc.data().discount,
              };
              this.items.push(this.datavalue);
    
          })
          })
      }else{
        this.items=[];
        this.getproductList();
      }
      
          },
            checkfeatured(e){
      console.log(e)
      console.log("ACTIVE")
      if(e.target.checked == true){
        this.items=[];
        this.loader=true;
        const db = firebase.firestore();
      db.collection("products")
        .where("id", "==", firebase.auth().currentUser.uid)
        .where("featured","==",true)
        .get()
        .then((snapshot) => {
          this.loader = false;
          snapshot.forEach((doc) => {
            this.id = doc.id;
              this.datavalue = {
                userid: doc.id,
                Image: doc.data().image,
                Id: doc.data().id,
                category: doc.data().category,
                description: doc.data().description,
                name: doc.data().name,
                skucode: doc.data().skucode,
                unitprice: doc.data().unitprice,
                mrp: doc.data().mrp,
                featured: doc.data().featured,
                available: doc.data().available,
                catalog: doc.data().catalog,
                variant: doc.data().variant,
                variants: doc.data().variants,
                extra: doc.data().extra,
                extras: doc.data().extras,
                weight: doc.data().weight,
                barcode: doc.data().barcode,
                brand: doc.data().brand,
                discount: doc.data().discount,
              };
              this.items.push(this.datavalue);
    
          })
          })
      }else{
        this.items=[];
        this.getproductList();
      }
      
          },
                      nofeatured(e){
      console.log(e)
      console.log("ACTIVE")
      if(e.target.checked == true){
        this.items=[];
        this.loader=true;
        const db = firebase.firestore();
      db.collection("products")
        .where("id", "==", firebase.auth().currentUser.uid)
        .where("featured","==",false)
        .get()
        .then((snapshot) => {
          this.loader = false;
          snapshot.forEach((doc) => {
            console.log(doc)
            this.id = doc.id;
              this.datavalue = {
                userid: doc.id,
                Image: doc.data().image,
                Id: doc.data().id,
                category: doc.data().category,
                description: doc.data().description,
                name: doc.data().name,
                skucode: doc.data().skucode,
                unitprice: doc.data().unitprice,
                mrp: doc.data().mrp,
                featured: doc.data().featured,
                available: doc.data().available,
                catalog: doc.data().catalog,
                variant: doc.data().variant,
                variants: doc.data().variants,
                extra: doc.data().extra,
                extras: doc.data().extras,
                weight: doc.data().weight,
                barcode: doc.data().barcode,
                brand: doc.data().brand,
                discount: doc.data().discount,
              };
              this.items.push(this.datavalue);
    
          })
          })
      }else{
        this.items=[];
        this.getproductList();
      }
      
          },
filtercatgory(e){
this.filtercat=e.target._value;
console.log(this.filtercat)
      if(e.target.checked == true){
        this.items=[];
        this.loader=true;
        const db = firebase.firestore();
      db.collection("products")
        .where("id", "==", firebase.auth().currentUser.uid)
        .where("category","array-contains", this.filtercat)
        .get()
        .then((snapshot) => {
          this.loader = false;
          snapshot.forEach((doc) => {
            this.id = doc.id;
              this.datavalue = {
                userid: doc.id,
                Image: doc.data().image,
                Id: doc.data().id,
                category: doc.data().category,
                description: doc.data().description,
                name: doc.data().name,
                skucode: doc.data().skucode,
                unitprice: doc.data().unitprice,
                mrp: doc.data().mrp,
                featured: doc.data().featured,
                available: doc.data().available,
                catalog: doc.data().catalog,
                variant: doc.data().variant,
                variants: doc.data().variants,
                extra: doc.data().extra,
                extras: doc.data().extras,
                weight: doc.data().weight,
                barcode: doc.data().barcode,
                brand: doc.data().brand,
                discount: doc.data().discount,
              };
              this.items.push(this.datavalue);
    
          })
          })
      }else{
        this.items=[];
        this.getproductList();
      }

},
              outofstock(e){
                this.outofstocking=e.target.checked;
      console.log(e)
      console.log("ACTIVE")
      if(e.target.checked == true){
        this.items=[];
        this.loader=true;
        const db = firebase.firestore();
      db.collection("products")
        .where("id", "==", firebase.auth().currentUser.uid)
        .where("available","==", false)
        .get()
        .then((snapshot) => {
          this.loader = false;
          snapshot.forEach((doc) => {
            this.id = doc.id;
              this.datavalue = {
                userid: doc.id,
                Image: doc.data().image,
                Id: doc.data().id,
                category: doc.data().category,
                description: doc.data().description,
                name: doc.data().name,
                skucode: doc.data().skucode,
                unitprice: doc.data().unitprice,
                mrp: doc.data().mrp,
                featured: doc.data().featured,
                available: doc.data().available,
                catalog: doc.data().catalog,
                variant: doc.data().variant,
                variants: doc.data().variants,
                extra: doc.data().extra,
                extras: doc.data().extras,
                weight: doc.data().weight,
                barcode: doc.data().barcode,
                brand: doc.data().brand,
                discount: doc.data().discount,
              };
              this.items.push(this.datavalue);
    
          })
          })
      }else{
        this.items=[];
        this.getproductList();
      }
      
          },

    onChangeEventHandler: function (event) {
      console.log("hai", event);
    },

    handlecb(csvvalues) {
      var db = firebase.firestore();
      var batch = db.batch();
      csvvalues.forEach((doc) => {
        if (this.catalog_data.includes(doc["name"])) {
          if (this.category_data.includes(doc["name"])) {
            doc["id"] = firebase.auth.currentUser.uid;
            doc["available"] = true;
            var docRef = db.collection("products").doc(); //automatically generate unique id
            batch.set(docRef, doc);
          } else {
            this.category_false = true;
          }
        } else {
          this.catalog_false = true;
        }
      });
      // batch.commit()
      //   .then(()=>{
      //     console.log("sucess")
      //   })
    },
    getcatalogList() {
      const db = firebase.firestore();
      this.catalog_data = [];
      db.collection("catalog")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.catalog_data.push(doc.data().name);
          });
          console.log("catalog", this.catalog_data);
        });
    },
    getcategoryList() {
      const db = firebase.firestore();
      this.categorydata = [];
      db.collection("category")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc.data());
            this.category_data.push(doc.data().name);
          });
          console.log("category", this.category_data);
        });
    },
    editfunction() {
      console.log("selected edit");
    },
    addproduct() {
      var app = this;
      app.$router.push("/productOrder");
    },
    updatefeature() {
      const db = firebase.firestore();
      db.collection("category")
        .where("catalog", "==", "Drink Menu")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            db.collection("category").doc(doc.id).update({
              catalog: "Drinks Menu",
            });
          });
          console.log("category over");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteProduct() {
      const db = firebase.firestore();
      db.collection("products")
        .where("id", "==", "7CstUZ4EWhRSGsK6dJIxR73TX9n2")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("Product Deleted", doc.data());
            doc.ref.delete();
          });
        });
    },
    deleteCategory() {
      const db = firebase.firestore();
      db.collection("catalog")
        .where("id", "==", "7CstUZ4EWhRSGsK6dJIxR73TX9n2")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("catalog Deleted", doc.data());
            doc.ref.delete();
          });
        });
    },
    close(){
      this.upload =false;
    },
    getproductList() {
      this.loader = true;
      const db = firebase.firestore();
      db.collection("products")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          this.loader = false;
          snapshot.forEach((doc) => {
            this.id = doc.id;
            if (doc.data().unitprice) {
              this.datavalue = {
                userid: doc.id,
                Image: doc.data().image,
                Id: doc.data().id,
                category: doc.data().category,
                description: doc.data().description,
                name: doc.data().name,
                skucode: doc.data().skucode,
                unitprice: doc.data().unitprice,
                mrp: doc.data().mrp,
                featured: doc.data().featured,
                available: doc.data().available,
                catalog: doc.data().catalog,
                variant: doc.data().variant,
                variants: doc.data().variants,
                extra: doc.data().extra,
                extras: doc.data().extras,
                weight: doc.data().weight,
                barcode: doc.data().barcode,
                brand: doc.data().brand,
                discount: doc.data().discount,
              };
              this.items.push(this.datavalue);
            } else {
              console.log("Deleted doument with id", doc.id);
              doc.ref.delete();
            }
            // this.idvalues.push(this.id)
            // self.Items = data;
            // return this.id + this.itemsvaluee
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteprodct($event,item){
    //  this.Idspro=[];
      console.log($event);
      console.log(item.userid);
      if($event.target.checked == true){
        this.delete=true;
        this.productId=item.userid;
        console.log("true",this.productId)
        this.Idspro.push(this.productId)
        console.log("Array",this.Idspro)
      }else{
         let found = this.Idspro.indexOf(item.userId)
        this.Idspro.splice(found, 1)
       // this.productId="";
        //this.Idspro
                console.log("false",this.Idspro)

      }

    },
    deleteOrder(item){
            console.log(item);
      this.$bvModal
        .msgBoxConfirm("Are you sure to delete this Product?", {
          title: "Delete Product",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.loader = true;
          this.deletecategory = value;
          console.log("Mugeshhjjhbf", this.deletecategory);
          if (this.deletecategory == true) {
            const db = firebase.firestore();
            db.collection("product")
              .doc(item.userid)
              .delete()
              .then(() => {
                // this.loader = false;
                this.item = {};
                this.imageFileDisp = null;
                this.img1 = null;
                this.items = [];
                this.getproductList();
                Vue.$toast.success("Product deleted successfully!", {
                  position: "top-right",
                });
              })
              .catch(function (error) {
                console.error("Error removing document: ", error);
                Vue.$toast.error(error, {
                  position: "top-right",
                });
              });
          }else{
            // this.loader=false;
          }
        })
        .catch((err) => {
          Vue.$toast.error(err, {
            position: "top-right",
          });
        });

    },
    deletepro(){
      if(this.Idspro.length != 0){

        for(let i=0; i<this.Idspro.length;i++){
        const db = firebase.firestore();
      db.collection("products")
      .doc(this.Idspro[i])
        .delete()
        .then((snapshot) => {
          this.items=[];
          this.deleteModal=false;
          this.getproductList();

        })
}

      }else{

                  Vue.$toast.error("Please Select product to delete.", {
            position: "top-right",
          });
this.deleteModal=false
      }
    },
    editOrder(item) {
      console.log(item, "Editing Item");
      this.$router.push({
        name: "editproduct",
        params: {
          id: item.userid,
          data: item,
        },
      });
    },
    viewOrder(item) {
      console.log(item, "ViewOrder");
      // console.log(item.item,"itemmm")
      // console.log(this.id,"itemcollctiomnSD")
      //  console.log(this.itemsvaluee,"daa")
      this.$router.push({
        name: "viewProduct",
        params: {
          id: item.id,
          data: item.item,
        },
      });
    },
       

  },
  mounted() {
    this.getcatalogList();
    this.getcategoryList();
    this.getproductList();
  },
  created: function () {
    this.symbol = localStorage.getItem("symbol");
    console.log(firebase.auth().currentUser);
    this.updatefeature();
    // this.deleteCategory();
    // this.deleteProduct();
    console.log("Created");
  },
};
</script>
<style scoped>
.headModify > table > thead > th {
  display: none;
}
.badge {
  border-radius: 3rem;
  padding-top: 1px;
  padding-bottom: 1px;
}
.custom-file-upload {
  background-color: #321fdb;
  border: 1px solid #ccc;
  display: inline-block;
  cursor: pointer;
  color: #fff;
  border: 0;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}
.table thead th {
  border-bottom: 0px !important;
}
ul {
    list-style-type: none;
}
.listing
{
  display: contents;
  position: relative;
  transform: translateX(-50%);
}

.product
{
  width: 240px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left:10px;
  margin-right:10px;
  position: relative;
  background: white;
}

.product a
{
  text-decoration: none;
}

.img-wrapper
{
  display: flex;
  width: 100%;
  height: 240px;
  border: 1px solid #afafaf;
  border-bottom: 0;
  overflow: hidden;
  text-align: center;
}



.info
{
  width: 100%;
  background: #000;
  color: #fff;
  position: relative;
  padding: 40px 10px 20px 10px;
  text-align: center;
  
  vertical-align: middle;
  transform: translateZ(0);
  box-shadow: 0 0 1px rgba(0,0,0,0);
  backface-visibility: hidden;
  transition-property: color,height;
  transition-duration: 0.3s,0.4s;
  transition-timing-function: ease-out;
  height: 83px;
}

.info:before
{
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  transform: scaleY(0);
  transform-origin: 50%;
  transition: transform 0.3s ease-out;
}

.info:after
{
  visibility: hidden;
  pointer-events: none;
  position: absolute;
  z-index: -1;
  content: '';
  border-style: solid;
  transition-duration: 0.3s;
  transition-property: transform;
  left: calc(50% - 11px);
  bottom: 0;
  border-width: 10px 10px 0 10px;
  border-color: black transparent transparent transparent;
}

.product:hover .info
{
  height: 40px;
}

.product:hover .info:before
{
  transform: scaleY(0.7);
}

.product:hover .info:after
{
  visibility: visible;
  transform: translateY(10px);
}

.title
{
  transition: transform 0.3s ease-out;
}
.title a
{
  color: inherit;
}
.product:hover .title
{
  transform: translateY(-18px);
  font-weight: bold;
  color: #000;
}

.price
{
  background: #e32d2c;
  position: absolute;
  font-size: 1.3em;
  padding: 4px 13px;
  top: -15px;
  right: 10px;
  border-radius:5px;
}

.price.sale
{
    border-radius:5px;
  background: #00ba2f;
}

.price.old
{
  font-size: 0.95em;
  padding: 4px 6px;
  text-decoration: line-through;
  top: -43px;
    border-radius:5px;

}

.actions-wrapper
{
  margin-top: 14px;
  display: flex;
  justify-content: space-around;
  visibility: hidden;
}

.actions-wrapper *
{
  width: 50%;
  padding: 2px 0;
  text-align: center;
  color: #191919;
  font-size: 0.95em;
  font-weight: bold;
}
.actions-wrapper *:before
{
  font-family: "Assistant";
  margin-right: 8px;
}
.wishlist
{
  border-left: 1px solid #afafaf;
}
.wishlist:hover
{
  color: #e32d2c;
  cursor:pointer;
}
/* .wishlist:before
{
  content: "\f08a";
} */

.cart:hover
{
  color: #0a75b9;
  cursor:pointer;
}
/* .cart:before
{
  content: "\f07a";
} */

.product:hover .actions-wrapper *
{
  visibility: visible;
}

.note
{
  position: absolute;
  top: -5px;
  left: 0;
  padding: 4px 8px;
  font-size: 12px;
}

.note.on-sale
{
  background: #00ba2f;
  color: #fff;
  border-radius: 5px;
}

.note.no-stock
{
    border-radius: 5px;
  background: #191919;
  color: #fff;
}
.discount-label {
 padding:8px; 
 position:relative;
  float:left;
  margin-top:35px;
   margin-left:60px;
width:50px;
-webkit-border-radius:0 4px 0 4px;
-moz-border-radius:0 4px 0 4px;
border-radius:0 4px 4px 0;

}

.discount-label:after { 

    right: 100%; 
    border: solid transparent; content: " "; 
    height: 0; 
    width: 0; 
    position: absolute;
    border-color: rgba(136, 183, 213, 0);
     
    border-width: 20px; 
    top: 50%; 
    margin-top: -20px;} 

    .discount-label:before {
  content: '';
  z-index: 2;
  position: absolute;
  top: 42%;
  right: 100%;
  width: 7px;
  height: 7px;
  opacity: .95;
  background: #ffffff;
  border-radius: 7px;
  -webkit-box-shadow: inset .5px 0 rgba(0, 0, 0, 0.6);
  box-shadow: inset .5px 0 rgba(0, 0, 0, 0.6);

}


    .discount-label span {
      color:#ffffff;
  font-size:14px;
text-align:center;
  font-family:'Assistant';

}


.red{ 
background-color:#E80707; 
}

.red:after{ 
border-right-color: #E80707;
  
}
.product-card {
    width: 250px;
    position: relative;
    box-shadow: 0 2px 7px #dfdfdf;
    background: #fafafa;
  border-radius:3rem;
  margin:5px 5px;
}

.badge {
position: absolute;
    left: 0px;
    top: 32px;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 700;
    background: red;
    color: #fff;
    padding: 3px 9px;
    border-radius: 5px 0px 15px 0px;}

.product-tumb {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 150px;
    padding: 10px;
}

.product-tumb img {
    max-width: 100%;
    max-height: 100%;
}

.product-details {
    padding: 25px;
}

.product-catagory {
    display: block;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #ccc;
    margin-bottom: 18px;
}

.product-details h4 a {
                        font-family: 'Assistant';

    font-weight: 500;
    display: block;
    margin-bottom: 18px;
    /* text-transform: uppercase; */
    color: #363636;
    text-decoration: none;
    transition: 0.3s;
}

.product-details h4 a:hover {
    color: #fbb72c;
}

.product-details p {
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 18px;
    color: #999;
}

.product-bottom-details {
    overflow: hidden;
    border-top: 1px solid #eee;
    padding-top: 20px;
}

.product-bottom-details div {
    float: left;
    width: 50%;
}

.product-price {
                        font-family: 'Montserrat';

    font-size: 18px;
    color: #fbb72c;
    font-weight: 600;
}

.product-price small {
                        font-family: 'Montserrat';
    font-size: 80%;
    font-weight: 400;
    text-decoration: line-through;
    display: inline-block;
    margin-right: 5px;
}

.product-links {
    text-align: right;
}

.product-links a {
  cursor: pointer;
    display: inline-block;
    margin-left: 5px;
    color: #e1e1e1;
    transition: 0.3s;
    font-size: 17px;
}

.product-links a:hover {
    color: #fbb72c;
}
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color:White;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #ff0000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.container1 {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container1 input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark1 {
  position: absolute;
  top: 10px;
  left: 12rem;
  height: 18px;
  width: 18px;
    background-color: #ccc;

}

/* On mouse-over, add a grey background color */
.container1:hover input ~ .checkmark1 {
    background-color:#ccc;

}

/* When the checkbox is checked, add a blue background */
.container1 input:checked ~ .checkmark1 {
  background-color: #ff0000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark1:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container1 input:checked ~ .checkmark1:after {
  display: block;
}

/* Style the checkmark/indicator */
.container1 .checkmark1:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

</style>
